/**
 * Sorted IANA time zone identifiers for profile / scheduling UIs.
 * Falls back to a small list if Intl.supportedValuesOf is unavailable.
 */
export function getSortedIanaTimeZones(): string[] {
  try {
    const fn = (Intl as unknown as { supportedValuesOf?: (k: string) => string[] })
      .supportedValuesOf;
    if (typeof fn === 'function') {
      return [...fn('timeZone')].sort((a, b) => a.localeCompare(b));
    }
  } catch {
    // ignore
  }
  return ['UTC', 'Europe/Rome', 'Europe/London', 'America/New_York', 'Asia/Tokyo'];
}

export function getBrowserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}
